<div #splashScreen id="splash-screen" [themeColor]="'bg-image'">
  <!-- ministry -->
  <ng-container *ngIf="desktop == Desktop.ErshadDesktop">
    <img
      class="tw-absolute tw-left-0 xl:tw-top-[30%] lg:tw-top-[40%] tw-bottom-0 2xl:tw-w-[600px] 2xl:tw-h-[600px] xl:tw-w-[540px] xl:tw-h-[540px] lg:tw-w-[400px] lg:tw-h-[400px] lg:tw-block tw-hidden"
      src="/assets/media/logos/Artboard.svg"
      alt="artBoard"
    />
    <img
      class="tw-absolute tw-right-0 xl:tw-top-[30%] tw-top-[40%] 2xl:tw-bottom-0 tw-bottom-7 2xl:tw-w-[620px] 2xl:tw-h-[620px] xl:tw-w-[500px] xl:tw-h-[500px] lg:tw-w-[350px] lg:tw-h-[350px] md:tw-w-[250px] md:tw-h-[250px] lg:tw-block tw-hidden"
      src="/assets/media/logos/map.svg"
      alt="map"
    />
  </ng-container>
  <!-- election -->
  <ng-container *ngIf="desktop == Desktop.ElectionDesktop">
    <img
      class="tw-absolute tw-left-0 xl:tw-top-[30%] lg:tw-top-[40%] tw-bottom-0 2xl:tw-w-[600px] 2xl:tw-h-[600px] xl:tw-w-[540px] xl:tw-h-[540px] lg:tw-w-[400px] lg:tw-h-[400px] lg:tw-block tw-hidden"
      src="/assets/media/logos/election-header.png"
      alt="header"
    />
    <img
      class="tw-absolute tw-right-0 xl:tw-top-[30%] tw-top-[40%] 2xl:tw-bottom-0 tw-bottom-7 2xl:tw-w-[620px] 2xl:tw-h-[620px] xl:tw-w-[500px] xl:tw-h-[500px] lg:tw-w-[350px] lg:tw-h-[350px] md:tw-w-[250px] md:tw-h-[250px] lg:tw-block tw-hidden"
      src="/assets/media/logos/election-map.png"
      alt="map"
    />
  </ng-container>

  <div
    class="tw-flex tw-items-center flex-column"
    style="margin-bottom: 35px"
  >
    <div id="wifi-loader">
      <img
        *ngIf="!isOwnerPanel"
        [src]="agentLogo || '/assets/media/logos/logo.png'"
        [ngClass]="
          desktop == Desktop.ErshadDesktop
            ? 'tw-brightness-50'
            : 'tw-w-[120px] tw-h-[120px]'
        "
        alt="Logo"
      />

      <img
        *ngIf="isOwnerPanel"
        class=""
        src="assets/media/gif/pishgamrayan.gif"
        style="width: 145px; height: initial"
      />

      <div class="text" [attr.data-text]="agentName"></div>
    </div>
  </div>
  <div
    #splashScreen
    [id]="
      desktop == Desktop.ErshadDesktop
        ? 'ministry-splash-screen-overlay'
        : 'splash-screen-overlay'
    "
  ></div>
</div>
